interface AccordionProps {
    header: string,
    children: React.ReactNode,
    group: string,
    index: string,
    type: 'radio' | 'checkbox'
    defaultChecked?: boolean
    checked?: boolean
    onChange?: () => void
}

export function Accordion({ header, children, group, index, type, defaultChecked, checked, onChange }: AccordionProps) {
    const accordionInput = defaultChecked ? 
                            <input type={type} className="accordion-state" id={`accordion-state-${index}`} name={ group } hidden defaultChecked={defaultChecked}/> :
                            <input type={type} className="accordion-state" id={`accordion-state-${index}`} name={ group } hidden checked={checked} onChange={onChange}/>
    return (
        <div className="accordion-container">
            {accordionInput}
            <label htmlFor={`accordion-state-${index}`}>
                <div className="accordion-button">
                    { header }
                    <p className="accordion-caret">&#9660;</p>
                </div>
            </label>
            <div className="accordion-content">
                <div className="accordion-inner">
                   {children} 
                </div>
            </div>
        </div>
    )
}